<template>
  <div class="row">
    <div class="col">
      <h5>Name Variations</h5>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <p>Use the following to set up name variations that you wish to associate with the Insurance company.</p>
    </div>
  </div>
  <div class="row">
    <div v-if="isLoading" class="col"><i class="fas fa-spinner fa-spin"></i> Loading...</div>
    <div v-else class="col">
      <!-- Heading -->
      <div class="row">
        <div class="col-6">
          <div class="input-group mb-3">
            <span class="input-group-text">Variation:</span>
            <input v-model="variationName" class="form-control" />
            <button class="btn btn-secondary btn-sm" type="button" @click="resetVariation">
              <i class="fas fa-undo"></i>
            </button>
            <button class="btn btn-primary btn-sm custom-add" type="button" @click="addVariation">Add</button>
          </div>
        </div>
        <div class="col"></div>
      </div>
      <!-- Listing -->
      <div class="custom-list-wrapper">
        <ul class="custom-list">
          <li v-for="company of insuranceLookup" :key="company.insuranceLookup" class="custom-insurance">
            <div class="row">
              <div class="col">
                <span>{{ company.insuranceName }}</span>
              </div>
              <div class="col-1 text-center">
                <div @click="removeInsuranceLookup(company.insuranceLookup)">
                  <i class="fas fa-trash custom-trash"></i>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
export default {
  name: 'InsuranceVariations',
  emits: ['refresh'],
  data() {
    return {
      variationName: null
    }
  },
  computed: {
    ...mapState(lookupStore, ['loading', 'selectedInsurance', 'insuranceLookup']),
    isLoading() {
      let _is = false
      if (this.loading) {
        if (this.loading.insuranceLookup) {
          _is = this.loading.insuranceLookup
        }
      }
      return _is
    }
  },
  methods: {
    ...mapActions(lookupStore, ['saveInsuranceLookup', 'deleteInsuranceLookup']),
    resetVariation() {
      this.variationName = null
    },
    async addVariation() {
      await this.saveInsuranceLookup({
        insurance: this.selectedInsurance,
        insuranceName: this.variationName
      })
      this.variationName = null
      this.$emit('refresh')
    },
    async removeInsuranceLookup(id) {
      await this.deleteInsuranceLookup(id)
      this.variationName = null
      this.$emit('refresh')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-add {
  border-left: 1px solid #fff;
}

.custom-list-wrapper {
  border-top: 1px solid #ccc;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 350px;
}
.custom-list {
  list-style: none;
  li {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
.custom-trash {
  color: rgb(173, 0, 0);
  :hover {
    cursor: pointer;
  }
}
</style>
